import { resolveReferenceAssets } from "@app/hooks/imageVariations/resolve";
import { isStaticPrompt } from "@app/hooks/imageVariations/variationRequest";
import { getVariationReferenceKeys } from "./wizardSteps";
import {
  formatOutdatedMessage,
  getChangedDependencies,
  getChangedReferences,
  getOutdatedAction,
  getVariationDependencies,
} from "./variationDependencies";

/**
 * Compares a generated image with its current campaign and references.
 * `dependencies` adds the campaign structure's keys and labels.
 */
export const getVariationOutdatedState = ({
  variation,
  dependencies,
  assets,
  selectedCampaign,
  video,
  templateData,
  isPromptEdited = false,
  isBusy = false,
}) => {
  const asset = assets?.find((a) => a.name === variation.key);
  const changedKeys = getChangedDependencies(
    asset?.sourceValue,
    getVariationDependencies(variation, dependencies),
    selectedCampaign,
  );
  const changedReferences = getChangedReferences(
    asset?.sourceReferences,
    getVariationReferenceKeys(variation),
    assets,
  );
  const isOutdated =
    !isBusy && (changedKeys.length > 0 || changedReferences.length > 0);

  if (!isOutdated) {
    return { changedKeys, changedReferences, isOutdated, action: null };
  }

  const referenceAssets = resolveReferenceAssets(assets, variation);
  const isStatic = isStaticPrompt(variation, {
    templateId: video.data?.templateId,
    campaign: selectedCampaign,
    customer: video.data?.customer,
    visual: referenceAssets[0],
    visuals: referenceAssets,
  });
  const action = getOutdatedAction({
    changedKeys,
    changedReferences,
    isStatic,
    isPromptEdited,
  });
  const referenceLabels = new Map(
    changedReferences.map((key) => [
      key,
      templateData?.assets?.find((a) => a.name === key)?.label ??
        templateData?.imageVariations?.find((v) => v.key === key)?.label ??
        key,
    ]),
  );

  return {
    changedKeys,
    changedReferences,
    isOutdated,
    action,
    message: formatOutdatedMessage(changedKeys, dependencies?.labels, {
      changedReferences,
      referenceLabels,
      action,
    }),
  };
};
